import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=d84a8db8&scoped=true&"
import script from "./Downloads.vue?vue&type=script&lang=ts&"
export * from "./Downloads.vue?vue&type=script&lang=ts&"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=d84a8db8&prod&scoped=true&lang=css&"
import style1 from "./Downloads.vue?vue&type=style&index=1&id=d84a8db8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84a8db8",
  null
  
)

export default component.exports